import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmUploadStore } from "./MdmUploadStore";
import { UploaderModal } from "./UploaderModal";

type PropsMdmUploader = {
  store: MdmUploadStore;
  children: React.ReactNode;
};

export const MdmUploader: React.FC<PropsMdmUploader> = observer((props) => {
  const { store, children } = props;
  return (
    <>
      {children}
      <UploaderModal store={store} />
    </>
  );
});
